import {Component, Input} from '@angular/core';
import {IBlockStatsConfig} from './block-stats.data';

@Component({
    selector: 'app-block-stats',
    templateUrl: './block-stats.component.html',
    styleUrls: ['./block-stats.component.scss'],
    standalone: false
})
export class BlockStatsComponent {

    @Input() config: IBlockStatsConfig;

}
